import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Dialog, {DialogContent} from 'material-ui/Dialog'
import Slide from 'material-ui/transitions/Slide'
import {Button} from '../../../components'
import Typography from 'material-ui/Typography'
import KeyboardArrowUpIcon from 'material-ui-icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from 'material-ui-icons/KeyboardArrowDown'
import IconButton from 'material-ui/IconButton'
import {FlowItemPanelWithCross} from '../../flow'
import {Panel} from '../../../components'

const ITEM_CONTAINER_WIDTH = 150
const ITEM_WIDTH = 48

const styles = (theme) => ({
  dialog: {
    height: '85%',
    bottom: 0,
    top: 'auto',
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
      height: '75%',
    },
    [theme.breakpoints.up('md')]: {
      height: '65%',
    },
  },
  dialogPaper: {
    background: theme.palette.background.modal,
  },
  bar: {
    display: 'flex',
    width: '100%',
    height: 80,
    padding: 16,
    boxSizing: 'border-box',
    position: 'fixed',
    bottom: 0,
    zIndex: theme.zIndex.appBar,
    background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
  },
  barItemContainer: {
    width: ITEM_CONTAINER_WIDTH,
    position: 'relative',
  },
  barItem: {
    width: ITEM_WIDTH,
    height: 48,
    top: 0,
    position: 'absolute',
    borderRadius: 3,
    overflow: 'hidden',
    backgroundColor: 'white',
    boxShadow: theme.shadows[4],
  },
  barBody: {
    flex: 1,
    padding: '14px 0',
  },
  barButton: {},
  gradient: {
    width: '100%',
    height: 8,
    background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
  },
})

function Transition(props) {
  return <Slide direction="up" {...props} />
}

class AddItemsToRemoval extends React.Component {

  static displayName = 'AddItemsToRemoval.component'

  state = {
    open: false,
  }

  setOpen = (open) => this.setState({open})

  onRemove = (id) => this.props.removeItem(id)

  getMainPhoto = (photos) => {
    if (photos.length === 0) return '/assets/imagen_no_disponible.png'
    let photo = photos.find(item => item.MainPhoto === true)
    if (typeof photo === 'undefined') photo = photos[0]
    return photo.Url || '/assets/imagen_no_disponible.png'
  }

  getPhotoSrc = (item) => {
    const photos = item.has('Photos') ? item.get('Photos') : item.get('Photo') // Inconsistency in data coming from server
    return `${this.getMainPhoto(photos)}?fit=fill&h=48&w=48`
  }

  render() {
    const {classes, items, show} = this.props

    if (show === false) {
      return null
    }

    const left = (ITEM_CONTAINER_WIDTH - ITEM_WIDTH) / items.length
    return (
      <div>
        <div className={classes.bar} onClick={() => this.setOpen(true)}>
          <div className={classes.barItemContainer}>
            {items.map((item, index) => {
              return (
                <div key={item.get('ID')} className={classes.barItem} style={{left: left * index}}>
                  <img width={48} height={48} src={this.getPhotoSrc(item)} alt={'item'}/>
                </div>
              )
            })}
          </div>
          <div className={classes.barBody}>
            <Typography variant={'body1'} style={{color: '#FFF'}}>
              {items.length} {items.length === 1 ? 'ítem' : 'ítems'}
            </Typography>
          </div>
          <div className={classes.barButton}>
            <IconButton>
              <KeyboardArrowUpIcon style={{color: '#FFF'}}/>
            </IconButton>
          </div>
        </div>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={() => this.setOpen(false)}
          transition={Transition}
          classes={{
            root: classes.dialog,
            paper: classes.dialogPaper,
          }}
        >
          <div className={classes.gradient}/>
          <div style={{display: 'flex', padding: 10}}>
            <div style={{width: 48}}/>
            <div style={{flex: 1, padding: '12px 0'}}>
              <Typography variant={'body2'} align={'center'} color={'textSecondary'}>Ítems para devolver</Typography>
            </div>
            <div style={{width: 48}}>
              <IconButton onClick={() => this.setOpen(false)}>
                <KeyboardArrowDownIcon/>
              </IconButton>
            </div>
          </div>
          <DialogContent style={{width: 500, maxWidth: '100%', margin: '0 auto'}}>
            <Panel style={{marginTop: 20}}>
              {items.map(item => {
                return (
                  <FlowItemPanelWithCross
                    key={item.get('ID')}
                    name={item.get('Name')}
                    imgSrc={this.getPhotoSrc(item)}
                    isButton={false}
                    onClick={() => this.onRemove(item.get('ID'))}
                  />
                )
              })}
            </Panel>
            <div style={{marginTop: 40}}>
              <Button variant={'primary'} fullWidth={true} disabled={items.length === 0} onClick={() => {
                this.props.continue()
                this.setOpen(false)
              }}>
                Enviar ítems
              </Button>
            </div>
            <div style={{marginTop: 10}}>
              <Button variant={'secondary'} fullWidth={true} onClick={() => this.setOpen(false)}>
                Agregar más ítems
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    )
  }

  static propTypes = {
    show: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    removeItem: PropTypes.func.isRequired,
    continue: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(AddItemsToRemoval)



// WEBPACK FOOTER //
// ./src/sections/remove/components/addItemsToRemoval.jsx